<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Module d'envoi de mails massif"
          class="bg-light shadow"
          title-tag="h6"
        >
          <b-card-group deck>
            <b-card
              title="Nouvel envoi"
              :img-src="require('@/assets/newsletters_send.jpg')"
              img-alt="Nouvel envoi"
              img-height="200px"
              img-top
              class="bg-light shadow"
            >
              <b-card-text>
                Envoyer une newsletters ou un mail à un ou plusieurs groupes de
                destinataires
              </b-card-text>
              <template #footer>
                <b-button :to="{ name: 'newslettersNew'}" variant="success"
                  ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                ></b-button>
              </template>
            </b-card>
            <b-card
              title="Envois en attente et archives"
              :img-src="require('@/assets/Email_queue.png')"
              img-height="200px"
              img-alt="Nouvel envoi"
              img-top
              class="bg-light shadow"
            >
              <b-card-text>
                Visualiser les envois de newsletters/mail
              </b-card-text>
              <template #footer>
                <b-button :to="{ name: 'newslettersList'}" variant="success"
                  ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                ></b-button>
              </template>
            </b-card>
            <b-card
              title="Groupes de destinataires"
              :img-src="require('@/assets/destinataires.jpg')"
              img-height="200px"
              img-alt="Groupes de destinataires"
              img-top
              class="bg-light shadow"
            >
              <b-card-text>
                Gérer les groupes de destinataires des newsletters
              </b-card-text>
              <template #footer>
                <b-button :to="{ name: 'newslettersGroups'}" variant="success"
                  ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                ></b-button>
              </template>
            </b-card>
            <b-card
              title="Configuration"
              :img-src="require('@/assets/config.jpg')"
              img-height="200px"
              img-alt="Configuration"
              img-top
              class="bg-light shadow"
            >
              <b-card-text>
                Configuration des newsletters
              </b-card-text>
              <template #footer>
                <b-button variant="success" :to="{name: 'manageNewslettersSettings'}"
                  ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                ></b-button>
              </template>
            </b-card>
          </b-card-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Newsletters",
  components: {},
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Module d'envoi de mails massif",
          active: true,
        },
      ],
      waiting: {},
      busy: false,
      loaded: false,
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>